import type { TenantEdition, TenantExam } from './tenant.entity';

/** Para onde o botão de um material leva, e se baixa ou abre. */
export interface EditionMaterial {
  href: string;
  /**
   * Nome do arquivo salvo, quando o PDF é do próprio site (`download` só vale
   * no mesmo domínio). Ausente = link externo, que abre em outra aba.
   */
  downloadName?: string;
}

/**
 * Qual material vale: **o PDF publicado com o site** (pasta `materiais/`, ver
 * `materiais/README.md`) e, sem ele, o link do `editions.mapper.ts`. Sem os
 * dois, `null` — e o botão não aparece.
 */
function resolve(
  pdfPath: string | undefined,
  url: string | undefined,
  downloadName: string,
): EditionMaterial | null {
  if (pdfPath) return { href: pdfPath, downloadName };
  if (url) return { href: url };
  return null;
}

/** "Baixar o ensaio": salvo como "Ensaio HCPA 2026.pdf". */
export function ensaioMaterial(
  exam: TenantExam,
  edition: TenantEdition,
): EditionMaterial | null {
  return resolve(
    edition.ensaioPdfPath,
    edition.ensaioDownloadUrl,
    `Ensaio ${exam.shortName} ${edition.year}.pdf`,
  );
}

/** Previsões Aristo: salvo como "Previsões Aristo HCPA 2026.pdf". */
export function previsoesMaterial(
  exam: TenantExam,
  edition: TenantEdition,
): EditionMaterial | null {
  return resolve(
    edition.previsoesPdfPath,
    edition.previsoesAristoUrl,
    `Previsões Aristo ${exam.shortName} ${edition.year}.pdf`,
  );
}

/** "Baixar o gabarito": só o PDF do site, salvo como "Gabarito HCPA 2026.pdf". */
export function gabaritoMaterial(
  exam: TenantExam,
  edition: TenantEdition,
): EditionMaterial | null {
  return resolve(
    edition.gabaritoPdfPath,
    undefined,
    `Gabarito ${exam.shortName} ${edition.year}.pdf`,
  );
}
